import { render, staticRenderFns } from "./ApprovalList.vue?vue&type=template&id=e6dcc346&scoped=true&"
import script from "./ApprovalList.vue?vue&type=script&lang=ts&"
export * from "./ApprovalList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6dcc346",
  null
  
)

export default component.exports